import * as Api from '../../../../global/js/api';
import { ifCond } from '../../../../global/helpers/handlebarsHelpers';
import { isLoggedin } from '../../../../global/js/utils';
import {saveSelectedStore} from "../../../../global/js/findInStore";
import { spinnerService } from "../../../../global/js/spinnerService";

const NS = 'StoreAvailability';
const CLS = 'storeAvailability';
const WG = '.' + CLS + '-';
const CLS_SELECTED = 'is-selected';
const CLS_LOADING = 'is-loading';
const EVT_SET_REGION = `${CLS}.setRegion`;

export class StoreAvailability {

	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$btn = $(`.${CLS}-btn`);
		this.$tbody = $(`.${CLS}-tbody`);
		this.$modal = $(`.${CLS}-modal`);
		this.$table = this.$el.find(`.${CLS}-table`);
		this.$regionSelect = this.$el.find(`.${CLS}-regionSelect`);
		this.$colourSelect = this.$el.find(`.${CLS}-colourSelect`);

		this.checkAvailabilityApi = this.$el.data('checkAvailabilityApi');
		this.productCode = this.$el.data('productCode');
		this.productType = this.$el.data('productType');
		this.lowStock = this.$el.data('lowStock');
		this.outOfStock = this.$el.data('outOfStock');
		this.storeList = [];

		this.dropdownValue = {
			selectedStore: '',
			selectedStoreName: '',
			selectedRegion: '',
			selectedRegionName: '',
		};
	}

	init() {
		this.initCustomEvent();
		this.checkLocalStorage();
		this.setStockTemplate();
		this.handleBtn();
		this.handleDropdown();
	}

	initCustomEvent() {
		this.el.addEventListener(EVT_SET_REGION, (e) => {
			let storeValue = e.detail;
			this.dropdownValue = storeValue;
			this.$regionSelect.val(storeValue.selectedRegion);
		});
	}

	checkLocalStorage() {
		if (isLoggedin()) return;

		if (window.localStorage) {
			let storeValue = window.localStorage.getItem(`bris.findInStore.value`);
			if (storeValue) {
				storeValue = JSON.parse(storeValue);
				this.dropdownValue = storeValue;
				this.$regionSelect.val(storeValue.selectedRegion);
			}
		}
	}

	handleBtn() {
		this.$btn.on('click', () => {
			this.checkAvailability(this.$btn);
		});
	}

	handleDropdown() {
		this.$colourSelect.on('change', () => {
			this.renderStock();
		});

		this.$regionSelect.on('change', () => {
			this.checkAvailability(this.$table);
		});
	}

	checkAvailability($parentEl) {
		$parentEl.addClass(CLS_LOADING);
		spinnerService.appendTo($parentEl, true);

		let $alert = $parentEl.next('.alert');
		if ($alert) {
			$alert.alert('close');
		}

		let storeId = this.$regionSelect.val() || '';
		let endpoint = `${this.checkAvailabilityApi}?productCode=${this.productCode}&storeId=${storeId}`;

		Api.getApi(endpoint).then((data) => {
			if (data.result == 'SUCCESS') {
				this.storeList = data.response.storeList;
				this.setStockStatus();
				this.reorderStore();
				this.renderStock();
				this.$modal.modal('show');
			} else {
				let errorMsg = data.message || `Can't check stock availability. Please try again.`;
				let errorTmpl = `
					<div class="alert alert-danger fade show mt-2 fsp-13 p-2" role="alert">
						${errorMsg}
						<button type="button" class="close" data-dismiss="alert" aria-label="Close" style="margin-top: -3px;">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
				`;

				$(errorTmpl).insertAfter($parentEl);
			}

			$parentEl.removeClass(CLS_LOADING);
			spinnerService.removeFrom($parentEl);
		}).catch((error) => {
			console.log(error);
			this.$table.removeClass(CLS_LOADING);
			spinnerService.removeFrom($parentEl);
		});
	}

	// set if variant in stock, low stock, or out-of-stock
	setStockStatus() {
		let stockStatus = (stockOnHand) => {
			let status = 'stockInfo--in';
			if (stockOnHand <= this.lowStock && stockOnHand > this.outOfStock) {
				status = 'stockInfo--low';
			} else if (stockOnHand <= this.outOfStock) {
				status = 'stockInfo--out';
			}

			return status;
		};

		this.storeList.forEach((store) => {
			// set selected store
			if (!isLoggedin()) {
				// make sure compare string to string
				if (`${this.dropdownValue.selectedStore}` === `${store.storeId}`) {
					store.selected = true;
				}
			}

			// check product type (generic, color, size, colorSize)
			switch (this.productType) {
				case "color":
					if (store.colorList && store.colorList.length > 0) {
						store.colorList.forEach((item) => {
							item.stockStatus = stockStatus(item.stockOnHand);
						});
					}
					break;

				case "size":
					if (store.sizeList && store.sizeList.length > 0) {
						store.sizeList.forEach((item) => {
							item.stockStatus = stockStatus(item.stockOnHand);
						});
					}
					break;

				case "colorsize":
					if (store.colorList && store.colorList.length > 0) {
						store.colorList.forEach((clr) => {
							if (clr.sizes && clr.sizes.length > 0) {
								clr.sizes.forEach((item) => {
									item.stockStatus = stockStatus(item.stockOnHand);
								})
							}
						});
					}
					break;

				default:
					// generic
					store.stockStatus = stockStatus(store.stockOnHand);
					store.stockText = 'Stock';
					break;
			}
		});
	}

	// selected store will show on the first list of modal
	reorderStore() {
		this.storeList.sort((x, y) => y.selected - x.selected);
	}

	setStockTemplate() {
		let itemFile = require('../../../widgets/storeAvailability/tmpl/storeAvailabilityStock.hbs');
		Handlebars.registerPartial('storeAvailabilityStock', itemFile);
		Handlebars.registerHelper('ifCond', ifCond);

		let itemTmpl = `
			{{> storeAvailabilityStock
				wg="storeAvailability"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(itemTmpl))();
		this.stockTmpl = Handlebars.template(precompiled);
	}

	renderStock() {
		let model = {
			storeList: this.storeList,
			selectedColor: this.$colourSelect.val(),
			lowStock: this.lowStock,
			outOfStock: this.outOfStock,
		};

		let html = this.stockTmpl(model);
		this.$tbody.html(html);
		this.handleMyStoreBtn();
	}

	handleMyStoreBtn() {
		this.$el.find(`.${CLS}-myStoreBtn`).each((i, btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				let $parent = $(btn).closest(`.${CLS}-trow`);
				let isSelected = $parent.hasClass(CLS_SELECTED);

				this.dropdownValue = {
					selectedStore: $parent.data('id'),
					selectedStoreName: $parent.data('name'),
					selectedRegion: this.$regionSelect.val(),
					selectedRegionName: this.$el.find(`.${CLS}-regionSelect option:selected`).text(),
				};

				// select store on regionSelector
				let regionStoreSelectorEl = document.querySelector('[data-wg="RegionStoreSelector"]');
				if (regionStoreSelectorEl) {
					let evt = new CustomEvent('regionStoreSelector.setRegion', {detail: this.dropdownValue});
					regionStoreSelectorEl.dispatchEvent(evt);
				}

				if (!isSelected) {
					$parent.addClass(CLS_LOADING);
					spinnerService.appendTo($parent, true);
					saveSelectedStore(this.dropdownValue, () => {
						this.$el.find(`.${CLS}-trow`).removeClass(CLS_SELECTED);
						$parent.addClass(CLS_SELECTED);
						$parent.removeClass(CLS_LOADING);
						spinnerService.removeFrom($parent);

						// updated selected store on storeList
						this.storeList.map((item) => {
							item.selected = item.storeId === this.dropdownValue.selectedStore;
						});
					});
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_04/_work/396/s/FrontEnd/src/views/widgets/storeAvailability/js/storeAvailability.js